import { BueroTypeResult, ResultPropsSonderbedarfe, ResultPropsUebergeordneteBedarfe } from '../../../../../types/Survey/Analysis/FactorValues'
import { PrebuildType } from '../../../../../types/Survey/Element'

const getTotal = (values: BueroTypeResult, isSum: boolean = false): number => {
  const simpleTypes = ['verkehrsflaechen', 'locker', 'drucker', 'workcafe', 'garderobe']
  const ignoreTypes = [
    'schreibtische',
    'mitarbeiter',
    'total',
    'desksharingPercentages',
    'anwesenheitPercentages',
    'anwesenheit',
    'WORKSTATIONS',
    'productionDistance',
    'floor',
  ]
  return Object.keys(values).reduce((acc, prebuildType) => {
    if (prebuildType === PrebuildType.STAUFLAECHE) {
      return (acc += values[prebuildType].practicalQM)
    } else if (prebuildType === PrebuildType.SONDERBEDARFE) {
      return (acc += values[prebuildType].reduce((acc: number, s: ResultPropsSonderbedarfe) => {
        return acc + s.practicalQM || 0
      }, 0))
    } else if (prebuildType === PrebuildType.EINZELBUEROS) {
      return (acc += values[prebuildType].practicalQM)
    } else if (prebuildType === PrebuildType.UEBERGEORDNETE_BEDARFE) {
      if (isSum) {
        return (acc += values[prebuildType].reduce((acc: number, s: ResultPropsUebergeordneteBedarfe) => {
          return acc + (isNaN(s.practicalQM) ? 0 : s.practicalQM)
        }, 0))
      } else {
        // do not add uebergeordnete bedarfe within single unit calculation (isSum = false means it's a single unit calculation)
        return acc
      }
    } else if (prebuildType === PrebuildType.EINZELARBEIT) {
      return (acc +=
        values[prebuildType].KLASSISCHE_ARBEIT.practicalQM +
        values[prebuildType].FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR.practicalQM +
        values[prebuildType].FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR.practicalQM)
    } else if (simpleTypes.includes(prebuildType)) {
      return (acc += values[prebuildType].practicalQM || 0)
    } else if (!ignoreTypes.includes(prebuildType)) {
      return (acc += Object.keys(values[prebuildType]).reduce((acc, prebuildSubType) => {
        return acc + values[prebuildType][prebuildSubType].practicalQM
      }, 0))
    }
    return acc
  }, 0)
}

export default getTotal
